import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"; 

import { ActivatedRoute, RouterModule } from "@angular/router";
import { UserService } from "src/app/features/user/user.service";
import { Router } from "@angular/router";
import { AuthService } from "src/app/core/auth/auth.service";

@Component({
  selector: "app-confirm-email-change",
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: `./confirm-email-change.html`,
})
export class ConfirmEmailChangeComponent implements OnInit {
  status: "loading" | "success" | "error" = "loading";
 
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private authService: AuthService,
  ) {}
  goToLogin(): void {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }
  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get("token");
    const email = this.route.snapshot.queryParamMap.get("email");

    if (!token || !email) {
      // this.loading = false;
      this.status = "error";
      return;
    }

    this.userService.confirmEmailChange(token, email).subscribe({
      next: () => {
        // this.loading = false;
        this.status = "success";
        this.authService.logout();
      },
      error: () => {
        // this.loading = false;
        this.status = "error";
      },
    });
  }
}
